/* eslint-disable */
export const maxLifetime = 0

export default [
[ 0, 100000 ],
[ 1, 87674 ],
[ 2, 85201 ],
[ 3, 84117 ],
[ 4, 83449 ],
[ 5, 82972 ],
[ 6, 82581 ],
[ 7, 82251 ],
[ 8, 81971 ],
[ 9, 81731 ],
[ 10, 81519 ],
[ 11, 81325 ],
[ 12, 81140 ],
[ 13, 80954 ],
[ 14, 80759 ],
[ 15, 80549 ],
[ 16, 80321 ],
[ 17, 80068 ],
[ 18, 79785 ],
[ 19, 79467 ],
[ 20, 79116 ],
[ 21, 78729 ],
[ 22, 78316 ],
[ 23, 77894 ],
[ 24, 77472 ],
[ 25, 77047 ],
[ 26, 76621 ],
[ 27, 76189 ],
[ 28, 75746 ],
[ 29, 75286 ],
[ 30, 74810 ],
[ 31, 74316 ],
[ 32, 73801 ],
[ 33, 73261 ],
[ 34, 72697 ],
[ 35, 72108 ],
[ 36, 71494 ],
[ 37, 70858 ],
[ 38, 70204 ],
[ 39, 69534 ],
[ 40, 68848 ],
[ 41, 68144 ],
[ 42, 67422 ],
[ 43, 66678 ],
[ 44, 65909 ],
[ 45, 65115 ],
[ 46, 64292 ],
[ 47, 63440 ],
[ 48, 62563 ],
[ 49, 61663 ],
[ 50, 60741 ],
[ 51, 59798 ],
[ 52, 58827 ],
[ 53, 57815 ],
[ 54, 56748 ],
[ 55, 55622 ],
[ 56, 54426 ],
[ 57, 53158 ],
[ 58, 51825 ],
[ 59, 50435 ],
[ 60, 48987 ],
[ 61, 47481 ],
[ 62, 45916 ],
[ 63, 44291 ],
[ 64, 42604 ],
[ 65, 40862 ],
[ 66, 39073 ],
[ 67, 37241 ],
[ 68, 35371 ],
[ 69, 33464 ],
[ 70, 31527 ],
[ 71, 29568 ],
[ 72, 27590 ],
[ 73, 25595 ],
[ 74, 23590 ],
[ 75, 21585 ],
[ 76, 19588 ],
[ 77, 17622 ],
[ 78, 15718 ],
[ 79, 13897 ],
[ 80, 12160 ],
[ 81, 10509 ],
[ 82, 8962 ],
[ 83, 7543 ],
[ 84, 6272 ],
[ 85, 5145 ],
[ 86, 4162 ],
[ 87, 3317 ],
[ 88, 2602 ],
[ 89, 2008 ],
[ 90, 1523 ],
[ 91, 1134 ],
[ 92, 829 ],
[ 93, 595 ],
[ 94, 419 ],
[ 95, 289 ],
[ 96, 195 ],
[ 97, 129 ],
[ 98, 82 ],
[ 99, 51 ],
[ 100, 31 ],
[ 101, 18 ],
[ 102, 10 ],
[ 103, 5 ],
[ 104, 2 ],
[ 105, 1 ],
[ 106, 0 ],
[ 107, 0 ],
[ 108, 0 ],
[ 109, 0 ],
[ 110, 0 ]
]
